import * as React from 'react'

import { FormikProps } from 'formik'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { TaxonomyForm } from 'modules/attendance/lib/forms/MapTimeBlockTaxonomyForm'

interface Props {
  form: FormikProps<TaxonomyForm>
  options: {
    label: string
    value: number
  }[]
  legalEntityId: number
  timeRangeCategoryId: string
}

const TaxonomyDropdown = ({ form, options, legalEntityId, timeRangeCategoryId }: Props) => {
  return (
    <SelectField
      options={options}
      none={i18n.t('time_tracking.settings.time_blocks.categories.modals.select')}
      onChange={(value) =>
        form.setValues({
          supplementTaxonomyId: value,
          legalEntityId: legalEntityId,
          timeRangeCategoryId: timeRangeCategoryId,
        })
      }
      error={form.touched.supplementTaxonomyId ? form.errors.supplementTaxonomyId : undefined}
      mandatory
    />
  )
}

export default TaxonomyDropdown
